import { EventIconAndTime } from "@ihs-widget/components/StatsConsole/Widgets/OverviewWidget/parts/EventIconAndTime";
import { EventNameAndPlayerName } from "@ihs-widget/components/StatsConsole/Widgets/OverviewWidget/parts/EventNameAndPlayerName";
import { formatEventTime } from "@ihs-widget/utils/functions";
import { switchDescription } from "../functions";

interface IVAREventsHeightProps {
    event_type: string;
    player: string;
    team: string;
    time: string;
    height: string;
    description: string;
    isDescBold?: boolean;
    isPlusSignNeeded?: boolean;
}

export const VAREventsHeightHome = ({ player, team, time, event_type, height, description, isDescBold = false, isPlusSignNeeded = false }: IVAREventsHeightProps) => {
    const formattedTime = formatEventTime(time, isPlusSignNeeded);
    return (
        <div className={`flex justify-start mx-[16px] mb-[8px] mnin-h-[${height}px] max-h-[${height}px]`}>
            <EventIconAndTime iconName={event_type} time={formattedTime} />
            <EventNameAndPlayerName 
                ml="8px" 
                mr="8px" 
                startPosition='start' 
                event_type={event_type} 
                player={player} 
                isDescBold={isDescBold} 
                description={switchDescription(event_type, description)} 
            />
        </div>
    )
}
